<template>
  <div>{{name}}
    <input ref="fileSelected" type="file" @change="load" />
    <img :src="imgSrc" alt="">
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import DemoModule from '../store/modules/demo.js'
import img from '../services/img'
export default {
  data () {
    return {
      name: '',
      imgSrc: ''
    }
  },
  methods: {
    ...mapActions(DemoModule, ['getDemoList']),
    async load (e) {
      let filePath = e.target.files[0]
      let dataUrl = await img.getFileDataUrl(filePath)
      this.imgSrc = await img.getImgBase64(dataUrl, 100, 100)
    }
  },
  async mounted () {
    let result = await this.getDemoList()
    this.name = result.name
  }
}
</script>

<style>
</style>
